<div class="eve2-consent-header">
  <h3 class="ds-title-3">{{ 'EVE2.de.consent.header.title' | translate }}</h3>
  <p class="ds-running-1 ds-color-core-neutral-8" [innerHTML]="'EVE2.de.consent.header.description' | translate "></p>
  <br>
  <p class="ds-running-1 ds-color-core-neutral-8" [innerHTML]="'EVE2.de.consent.header.description_2' | translate "></p>
</div>

<div class="eve2-consent-summary">
  <h1 class="ds-heading-1">{{ 'EVE2.de.consent.summary.title' | translate }}</h1>
  <ul>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc1' | translate }}</li>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc2' | translate }}</li>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc3' | translate }}</li>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc4' | translate }}</li>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc5' | translate }}</li>
    <li class="ds-ui-1">{{ 'EVE2.de.consent.summary.desc6' | translate }}</li>
  </ul>
</div>

<p class="ds-running-1 ds-color-core-neutral-8" [innerHTML]="'EVE2.de.consent.summary.external.help' | translate"></p>
<br>
<p class="ds-running-1 ds-color-core-neutral-8" [innerHTML]="'EVE2.de.consent.summary.external.contract' | translate"></p>
<br>

<div class="eve2-consent-contract">
  <h1 class="ds-heading-1">{{ 'EVE2.de.consent.document.title' | translate }}</h1>

  <form [formGroup]="form" #formEl="ngForm" (ngSubmit)="onSubmit()">
    <div class="eve2-consent-document" (click)="onDocumentDownload()">
      <p>
        <app-ds-icon name="file-text"></app-ds-icon>
        <span class="ds-ui-2">{{ 'EVE2.de.consent.document.download' | translate }}</span>
      </p>
    </div>
    <app-ds-checkbox
      [label]="'EVE2.de.consent.document.agreeText' | translate"
      [errorMessage]="'EVE2.de.consent.document.error' | translate"
      [checked]="acceptControl.value"
      [hasError]="formEl.submitted && acceptControl.invalid"
      [tabIndex]="-1"
      (clicked)="onToggleConsent()"
    >
    </app-ds-checkbox>

    <p class="ds-running-1 ds-color-core-neutral-8" [innerHTML]="'EVE2.de.consent.document.notice' | translate "></p>

    <div class="eve2-consent-actions" [class.web-app]="webApp">
      <app-ds-button [tabIndex]="-1" variant="primary" type="submit" [isLoading]="loading">{{ 'EVE2.de.consent.action.accept' | translate }}</app-ds-button>
      <app-ds-button [tabIndex]="-1" variant="outline" type="button" (clicked)="onReviewLater()">{{ 'EVE2.de.consent.action.later' | translate }}</app-ds-button>
    </div>
  </form>
</div>
